import { render, staticRenderFns } from "./wv-daily-insights.vue?vue&type=template&id=0ba9912d&scoped=true&"
import script from "./wv-daily-insights.vue?vue&type=script&lang=js&"
export * from "./wv-daily-insights.vue?vue&type=script&lang=js&"
import style0 from "./wv-daily-insights.vue?vue&type=style&index=0&id=0ba9912d&lang=scss&scoped=true&"
import style1 from "./wv-daily-insights.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba9912d",
  null
  
)

export default component.exports